import { useState, useCallback } from "react";
import { DocumentDuplicateIcon } from "@heroicons/react/24/outline";
import { t } from "i18next";

interface CopyToClipboardButtonProps {
  text: string;
}

export default function CopyToClipboardButton({ text }: CopyToClipboardButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = useCallback(
    async (e: React.MouseEvent) => {
      e.stopPropagation();
      try {
        await navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } catch {
        // clipboard API unavailable
      }
    },
    [text]
  );

  return (
    <div className="relative inline-flex items-center">
      <button
        type="button"
        onClick={handleCopy}
        className={`flex items-center justify-center w-7 h-7 rounded-full border transition-colors ${
          copied
            ? "bg-white border-blue-500"
            : "bg-transparent border-transparent hover:bg-white hover:border-blue-500 active:bg-white active:border-blue-500"
        }`}
      >
        <DocumentDuplicateIcon className="h-4 w-4 text-gray-500" />
      </button>

      {copied && (
        <div className="absolute left-full ml-2 top-1/2 -translate-y-1/2 z-50 flex items-center gap-2 bg-white shadow-md rounded-lg px-3 py-2 whitespace-nowrap border border-gray-100">
          <DocumentDuplicateIcon className="h-4 w-4 text-green-600 shrink-0" />
          <span className="text-sm text-gray-700">
            {t("workorder:copiedToClipboard")}
          </span>
        </div>
      )}
    </div>
  );
}
